module.exports = __webpack_public_path__ + "img/lg_ring_0_0_null_0@3x.ae3dce1e.png";